import { mapState } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState("equipments", ["equipmentProfile"])
  },
  methods: {
    async goToInspection() {
      if (this.$store.getters["auth/adminAndUp"]) {
        this.$router.push({
          name: "New/Inspection",
          params: { equipId: this.$route.params.id }
        });
      } else {
        const RADIO_METROS = 20;
        try {
          const { coords } = await this.geoFindMe();
          const lt = coords.latitude;
          const ln = coords.longitude;
          /*  if (!this.equipmentProfile?.location?.length == 2) {
                    return this.$router.push({
                      name: "New/Inspection",
                      params: { equipId: this.$route.params.id }
                    });
                  } */
          var lt1 = this.equipmentProfile.location[0];
          var ln1 = this.equipmentProfile.location[1];
          var dLat = ((lt - lt1) * Math.PI) / 180;
          var dLon = ((ln - ln1) * Math.PI) / 180;
          var a =
            0.5 -
            Math.cos(dLat) / 2 +
            (Math.cos((lt1 * Math.PI) / 180) *
              Math.cos((lt * Math.PI) / 180) *
              (1 - Math.cos(dLon))) /
              2;
          const distance = Math.round(6371000 * 2 * Math.asin(Math.sqrt(a)));

          if (distance > RADIO_METROS) {
            if (distance > 1000) {
              this.$dialog.notify.error(
                this.$t("notifications.error.gpsBusinessLogic.newInspection") +
                  `${distance / 1000}`,
                {
                  position: "top-right",
                  timeout: 5000
                }
              );
            } else {
              this.$dialog.notify.error(
                this.$t("notifications.error.gpsBusinessLogic.newInspection") +
                  `${distance}`,
                {
                  position: "top-right",
                  timeout: 5000
                }
              );
            }
          } else {
            this.$router.push({
              name: "New/Inspection",
              params: { equipId: this.$route.params.id }
            });
          }
        } catch (error) {
          switch (error.code) {
            case error.PERMISSION_DENIED:
              this.$dialog.notify.error(
                this.$t("notifications.error.gpsBusinessLogic.permission"),
                {
                  position: "top-right",
                  timeout: 5000
                }
              );

              break;
            case error.POSITION_UNAVAILABLE:
              this.$dialog.notify.error(
                this.$t("notifications.error.gpsBusinessLogic.position"),
                {
                  position: "top-right",
                  timeout: 5000
                }
              );
              break;
            case error.TIMEOUT:
              this.$dialog.notify.error(
                this.$t("notifications.error.gpsBusinessLogic.timeout"),
                {
                  position: "top-right",
                  timeout: 5000
                }
              );

              break;
            case error.UNKNOWN_ERROR:
              this.$dialog.notify.error(
                this.$t("notifications.error.gpsBusinessLogic.unknown"),
                {
                  position: "top-right",
                  timeout: 5000
                }
              );

              break;
          }
        }
      }
    },
    geoFindMe() {
      if (!navigator.geolocation) {
        return false;
      } else {
        return new Promise((res, rej) => {
          navigator.geolocation.getCurrentPosition(res, rej);
        });
      }
    }
  }
};
